import { EventEmitter } from "fbemitter";

export const EVENT_TOPICS = {
  ON_NEWS_DELETED: "OnNewsDeleted",
  ON_USER_DELETED: "OnUserDeleted",
  ON_LANGUAGE_CHANGED: "ON_LANGUAGE_CHANGED",
};

export default new EventEmitter();
